const inviteCreateUser = {
  toastr: 'Conta Criada',
  toastr1: 'A conta foi criada com sucesso'
};

export default inviteCreateUser;
